import { Link } from 'react-router-dom';
import {
  Box,
  Container,
  Link as MuiLink,
  Stack,
  Typography,
} from '@mui/material';
import { useAuth } from 'react-oidc-context';
import { useMemo } from 'react';
import { observer } from 'mobx-react';

const LEGAL_LINKS = [
  { to: '/legal/terms', label: 'Terms' },
  { to: '/legal/privacy', label: 'Privacy' },
  { to: '/legal/acceptable-use', label: 'Acceptable Use' },
  { to: '/legal/security', label: 'Security Disclosure' },
  { to: '/public/help', label: 'Help & Support' },
];

function Footer({ maxWidth = 'xl', ...props }) {
  const { isAuthenticated = false } = useAuth() || {};
  const { sx, ...otherProps } = props;

  const links = useMemo(() => {
    return LEGAL_LINKS.map((link, index) =>
      index === 4 && isAuthenticated
        ? { to: '/help', label: 'Help & Support' }
        : link,
    );
  }, [isAuthenticated]);

  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 2,
        px: 2,
        borderTop: 1,
        borderColor: 'divider',
        backgroundColor: 'grey.50',
        ...sx,
      }}
      {...otherProps}>
      <Container maxWidth={maxWidth}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', sm: 'center' },
            gap: 2,
          }}>
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            {links.map(({ to, label }, index) => (
              <Box key={to}>
                <MuiLink
                  component={Link}
                  to={to}
                  variant="body2"
                  color="text.secondary"
                  underline="hover">
                  {label}
                </MuiLink>

                {index < links.length - 1 && (
                  <Typography
                    sx={{ ml: 1 }}
                    component="span"
                    variant="body2"
                    color="text.secondary">
                    |
                  </Typography>
                )}
              </Box>
            ))}
          </Stack>

          <Typography variant="body2" color="text.secondary">
            &copy; {new Date().getFullYear()} Service Xcelerator, Inc. All
            rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default observer(Footer);
